import { FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import { t } from 'i18next';
import { useContext, useEffect, useState } from 'react';
import { GetLast5FSTSubjectSpecificAnalytics } from '../Components/analyticsHooks/UseGetPieChartData';
import GridContainer from '../Components/Grid/GridContainer';
import { LoginContext } from '../contexts/LoginContext';
import ApexChart from '../Dashboard/ApexChart';
import TopicPulseTable from './TopicPulseTable';

const TopicPulseAnalytics = ({ topicPulseAnalyticsData, pieChartAnalyticsDataSpecific }) => {
    const { UserId } = useContext(LoginContext);
    const [selectedSubject, setSelectedSubject] = useState("");
    const [matrixTableData, setMatrixTableData] = useState([])
    const [loading, setLoading] = useState(false);
    const subjects = Object.keys(pieChartAnalyticsDataSpecific || {}).filter(
        (key) => key !== "allSubject"
    );

    const getMatirxData = async (subject) => {
        try {
            setLoading(true);
            const matirxData = await GetLast5FSTSubjectSpecificAnalytics(UserId, subject);
            if (matirxData != null) {
                console.log("matirxData -", matirxData);
                setMatrixTableData(matirxData);
            };
            setLoading(false);
        } catch (e) {
            setLoading(false);
            console.log("errrr getting pie data", e);
        }
    }

    useEffect(() => {
        console.log(subjects, '-subs')
        if (subjects.length > 0 && !selectedSubject) {
            const firstSubject = subjects[1];
            setSelectedSubject(firstSubject);
            getMatirxData(firstSubject);
        }
    }, [subjects]);

    const handleChange = (event) => {
        console.log(event.target.value, '- selected subject')
        setSelectedSubject(event.target.value);
        getMatirxData(event.target.value);
    };

    return (
        <div>
            <GridContainer>
                {subjects.map((subject) => (
                    <Grid
                        key={subject}
                        item
                        xs={12}
                        sm={6}
                        md={3}
                        sx={{ textAlign: "center" }}
                    >
                        <ApexChart
                            chartHeight={200}
                            data={pieChartAnalyticsDataSpecific[subject]}
                            type={'pie'}
                        />

                        {/* Radio Button */}
                        <RadioGroup
                            value={selectedSubject}
                            onChange={handleChange}
                            row
                            sx={{ justifyContent: "center" }}
                        >
                            <FormControlLabel
                                value={subject}
                                control={<Radio sx={{ fontSize: '18px' }} />}
                                label={<span style={{ color: '#3C4858', fontFamily: 'poppins', fontWeight: '600', fontSize: '18px' }}>&nbsp;{subject}</span>}
                            />
                        </RadioGroup>
                    </Grid>
                ))}
                <Grid item xs={12} sm={6} md={3} sx={{ textAlign: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                        <div
                            style={{
                                borderRadius: '50%',
                                width: '15px',
                                height: '15px',
                                backgroundColor: '#dbdbdb',
                                marginRight: '10px',
                                fontFamily: 'Poppins',
                                fontSize: '18px',
                                color: '#2e2f30'
                            }}
                        ></div>
                        <span style={{ fontFamily: 'Poppins', fontSize: '18px', color: '#2e2f30' }}>{t("unattempted")}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                        <div
                            style={{
                                borderRadius: '50%',
                                width: '15px',
                                height: '15px',
                                backgroundColor: '#23eb23',
                                marginRight: '10px',
                                fontFamily: 'Poppins',
                                fontSize: '18px',
                                color: '#2e2f30'
                            }}
                        ></div>
                        <span style={{ fontFamily: 'Poppins', fontSize: '18px', color: '#2e2f30' }}>{t("correct")}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div
                            style={{
                                borderRadius: '50%',
                                width: '15px',
                                height: '15px',
                                backgroundColor: '#ff6961',
                                marginRight: '10px',
                                fontFamily: 'Poppins',
                                fontSize: '18px',
                                color: '#2e2f30'
                            }}
                        ></div>
                        <span style={{ fontFamily: 'Poppins', fontSize: '18px', color: '#2e2f30' }}>{t("incorrect")}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div
                            style={{
                                borderRadius: '50%',
                                width: '15px',
                                height: '15px',
                                backgroundColor: '#ffc57a',
                                marginRight: '10px',
                                fontFamily: 'Poppins',
                                fontSize: '18px',
                                color: '#2e2f30'
                            }}
                        ></div>
                        <span style={{ fontFamily: 'Poppins', fontSize: '18px', color: '#2e2f30' }}>{t("Opportunity")}</span>
                    </div>

                </Grid>
            </GridContainer>
            <TopicPulseTable matrixTableData={matrixTableData && matrixTableData} isLoading={loading} />
        </div>
    );
}

export default TopicPulseAnalytics;
